import DataReleaseHistory from '@/modules/calendar/components/data/data-release-history';

// Fixed when the module loads, so re-rendering a chat message never changes the chart's date.
const date = new Date().toISOString();

// Renders `$widget:data-history:<dataReleaseId>` tokens in chat messages.
export default function DataHistoryChatEmbed({ id }: { id: string }) {
  return <DataReleaseHistory dataReleaseId={parseInt(id)} date={date} />;
}
